import {Injectable} from '@angular/core';
import {Notificacao} from './notificacao';
import {NotificacaoEnum} from './notificacao.enum';
import {NotificacaoService} from './notificacao.service';
export class MensagemUtil {
/**
 * @param {?} notificacaoService
 */
constructor (private notificacaoService: NotificacaoService) {}
/**
 * @param {?} msg
 * @param {?} titulo
 * @param {?=} timeout
 * @return {?}
 */
sucesso(msg: string, titulo: string, timeout?: number) {
    const /** @type {?} */ notificacao: Notificacao = new Notificacao();
    notificacao.mensagem = msg;
    notificacao.tipo =   NotificacaoEnum.success;
    notificacao.titulo = titulo;
    notificacao.timeout = timeout;
    this.notificacaoService.adicionar(notificacao);
  }
/**
 * @param {?} msg
 * @param {?} titulo
 * @param {?=} timeout
 * @return {?}
 */
erro(msg: string, titulo: string, timeout?: number) {
    const /** @type {?} */ notificacao: Notificacao = new Notificacao();
    notificacao.mensagem = msg;
    notificacao.tipo =   NotificacaoEnum.danger;
    notificacao.titulo = titulo;
    notificacao.timeout = timeout;
    this.notificacaoService.adicionar(notificacao);
  }
/**
 * @param {?} msg
 * @param {?} titulo
 * @param {?=} timeout
 * @return {?}
 */
info(msg: string, titulo: string, timeout?: number) {
    const /** @type {?} */ notificacao: Notificacao = new Notificacao();
    notificacao.mensagem = msg;
    notificacao.tipo =   NotificacaoEnum.info;
    notificacao.titulo = titulo;
    notificacao.timeout = timeout;
    this.notificacaoService.adicionar(notificacao);
  }
/**
 * @param {?} msg
 * @param {?} titulo
 * @param {?=} timeout
 * @return {?}
 */
warning(msg: string, titulo: string, timeout?: number) {
    const /** @type {?} */ notificacao: Notificacao = new Notificacao();
    notificacao.mensagem = msg;
    notificacao.tipo =   NotificacaoEnum.warning;
    notificacao.titulo = titulo;
    notificacao.timeout = timeout;
    this.notificacaoService.adicionar(notificacao);
  }


static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NotificacaoService, },
];
}

function MensagemUtil_tsickle_Closure_declarations() {
/** @type {?} */
MensagemUtil.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MensagemUtil.ctorParameters;
/** @type {?} */
MensagemUtil.prototype.notificacaoService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
